var DimensionFilters = {
  instances: [],
  observedGrid: null,

  register(instance) {
    this.instances.push(instance);
    this.observeGrid();
    this.apply();
  },

  observeGrid() {
    if (this.observedGrid) return;
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    var reapply = typeof debounce === 'function' ? debounce(() => this.apply(), 50) : () => this.apply();
    this.observedGrid = new MutationObserver(reapply);
    this.observedGrid.observe(container, { childList: true, subtree: true });
  },

  apply() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var ranges = {};
    this.instances.forEach((instance) => {
      ranges[instance.dimension] = instance;
    });

    var visibleCount = 0;
    grid.querySelectorAll('.collection-product-card').forEach((card) => {
      var visible = true;

      if (ranges.width && card.dataset.dimWidth !== undefined) {
        var width = Number(card.dataset.dimWidth);
        var widthRange = ranges.width.getRange();
        visible = visible && width >= widthRange.min && width <= widthRange.max;
      }
      if (ranges.height && card.dataset.dimHeight !== undefined) {
        var height = Number(card.dataset.dimHeight);
        var heightRange = ranges.height.getRange();
        visible = visible && height >= heightRange.min && height <= heightRange.max;
      }

      card.classList.toggle('dimension-filter-hidden', !visible);
      if (visible) visibleCount += 1;
    });

    this.updateURL(ranges);
    document.dispatchEvent(
      new CustomEvent('dimension-filter:change', { detail: { visibleCount: visibleCount } })
    );
  },

  updateURL(ranges) {
    var params = new URLSearchParams(window.location.search);

    Object.keys(ranges).forEach((dimension) => {
      var instance = ranges[dimension];
      var key = instance.paramKey();
      if (instance.isDefaultRange()) {
        params.delete('dim_min_' + key);
        params.delete('dim_max_' + key);
      } else {
        var range = instance.getRange();
        params.set('dim_min_' + key, range.min);
        params.set('dim_max_' + key, range.max);
      }
    });

    var query = params.toString();
    var newUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
    if (newUrl !== window.location.pathname + window.location.search + window.location.hash) {
      history.replaceState(history.state, '', newUrl);
    }
  },
};

class DimensionRangeFilter extends HTMLElement {
  constructor() {
    super();
    this.dimension = this.dataset.dimension;
    this.absoluteMin = Number(this.dataset.min);
    this.absoluteMax = Number(this.dataset.max);
    this.minInput = this.querySelector('[data-role="min-input"]');
    this.maxInput = this.querySelector('[data-role="max-input"]');
    this.minLabel = this.querySelector('[data-role="min-label"]');
    this.maxLabel = this.querySelector('[data-role="max-label"]');
    this.rangeTrack = this.querySelector('.facets__range');

    if (!this.minInput || !this.maxInput) return;

    this.applyFromSearchParams();

    ['input', 'change'].forEach((type) => {
      this.minInput.addEventListener(type, (e) => e.stopPropagation());
      this.maxInput.addEventListener(type, (e) => e.stopPropagation());
    });
    this.minInput.addEventListener('input', this.onMinInput.bind(this));
    this.maxInput.addEventListener('input', this.onMaxInput.bind(this));

    this.updateLabels();
    this.fillTrack();
    DimensionFilters.register(this);
  }

  paramKey() {
    return this.dimension === 'height' ? 'h' : 'w';
  }

  applyFromSearchParams() {
    var params = new URLSearchParams(window.location.search);
    var key = this.paramKey();
    var minParam = params.get('dim_min_' + key);
    var maxParam = params.get('dim_max_' + key);

    if (minParam !== null) {
      var minValue = Number(minParam);
      if (!Number.isNaN(minValue)) {
        this.minInput.value = Math.min(Math.max(minValue, this.absoluteMin), this.absoluteMax);
      }
    }
    if (maxParam !== null) {
      var maxValue = Number(maxParam);
      if (!Number.isNaN(maxValue)) {
        this.maxInput.value = Math.max(Math.min(maxValue, this.absoluteMax), this.absoluteMin);
      }
    }
  }

  onMinInput() {
    var minValue = Number(this.minInput.value);
    var maxValue = Number(this.maxInput.value);
    if (minValue > maxValue) {
      this.minInput.value = maxValue;
    }
    this.updateLabels();
    this.fillTrack();
    DimensionFilters.apply();
  }

  onMaxInput() {
    var minValue = Number(this.minInput.value);
    var maxValue = Number(this.maxInput.value);
    if (maxValue < minValue) {
      this.maxInput.value = minValue;
    }
    this.updateLabels();
    this.fillTrack();
    DimensionFilters.apply();
  }

  formatValue(value) {
    var rounded = Math.round(value * 10) / 10;
    return rounded % 1 === 0 ? String(Math.round(rounded)) : String(rounded);
  }

  updateLabels() {
    if (this.minLabel) this.minLabel.textContent = this.formatValue(Number(this.minInput.value));
    if (this.maxLabel) this.maxLabel.textContent = this.formatValue(Number(this.maxInput.value));
  }

  fillTrack() {
    if (!this.rangeTrack) return;
    var span = this.absoluteMax - this.absoluteMin;
    if (span <= 0) return;
    var minPercent = ((Number(this.minInput.value) - this.absoluteMin) / span) * 100;
    var maxPercent = ((Number(this.maxInput.value) - this.absoluteMin) / span) * 100;
    this.rangeTrack.style.setProperty('--range-min', minPercent + '%');
    this.rangeTrack.style.setProperty('--range-max', maxPercent + '%');
  }

  getRange() {
    return { min: Number(this.minInput.value), max: Number(this.maxInput.value) };
  }

  isDefaultRange() {
    return (
      Number(this.minInput.value) <= this.absoluteMin && Number(this.maxInput.value) >= this.absoluteMax
    );
  }
}
customElements.define('dimension-range-filter', DimensionRangeFilter);
